module.exports = __webpack_public_path__ + "static/lonely-hero-mobile-0ae527300bf98daf52271faf3c07654b.jpg";